import { TFunction } from 'i18next';

export const getSubmitButtonText = (
   isSendPalletsDataFileUploaded: boolean,
   isSendPalletsDataFileVerified: boolean,
   isModalEditMode: boolean,
   t: TFunction,
) => {
   if (isSendPalletsDataFileUploaded && !isSendPalletsDataFileVerified) {
      return t('sendPalletsModal.utils.verifyAddresses');
   }
   return isModalEditMode
      ? t('sendPalletsModal.utils.saveChanges')
      : t('sendPallets.sendPalletsBtn');
};
